import request from '@/http/request'

const base = `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/special/type/configuration`

export const getTableData = params => {
  return request.post(`${base}/findSpecialTypeConfigurationPage`, params)
}

export const addData = params => {
  return request.post(`${base}/add`, params, { hiddenError: true })
}

export const updateData = params => {
  return request.post(`${base}/update`, params, { hiddenError: true })
}

export const getFilterOptions = () => {
  return request.get(`${base}/findDropDown`)
}

export const previewDisable = params => {
  return request.get(`${base}/findSkuListBySpecialCode`, { params })
}
export const disableRecords = id => {
  return request.get(`${base}/disable/${id}`)
}

export const downloadData = params => {
  return request.post(`${base}/exportSpecialTypeConfiguration`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getExceptionTypeList = () => {
  return request.get(`${base}/getExceptionTypeList`)
}

export const findSpecialCodeAndType = () => {
  return request.get(`${base}/findSpecialCodeAndType`)
}
